
import Top from "../components/Top";
//import styles from "../style.module.css";
import "../index.css"
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from 'react-bootstrap/Spinner';
import { API_BASE_URL } from "../api/config";
import parse from 'html-react-parser';

function About() {


  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['about-page'],
    queryFn: async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/user/pages/about`);
        return await res.json();
      } catch (error) {
        return error
      }
    },
  })
  /* const options = {
    replace({ attribs, children }) {
      if (!attribs) {
        return;
      }

    }
  } */
  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
      <Spinner animation="border" role="status" style={{height:"89px", width:"89px"}}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }

  if (isError) {
    return (
      <p>An Error Occurred : {error.message}</p>
    )
  }



  return (

    <div className="about" >
      <div className="container aboutContent">
        <div className="aboutHeader">
          <h6>About AAER</h6>
          <h3>{data?.title}</h3>
        </div>
        {/* {
          data?.metadata?.about?.map(a => <p key={a}>{a}</p>)
        }

        <div className="why">
          {
            data?.metadata?.whyChooseUs.map(w => {
              return <div key={w?.subtitle}>
                <h6 className="pre">{w?.subtitle}</h6>
                <h3 className="headText">{w?.title}</h3>
                <p>{w?.description}</p>
              </div>
            })
          }



        </div>

        <div className="goal">
          <div className="row">
            <div className="col-12">

              {
                data?.metadata?.goals.map(w => {
                  return <div key={w?.title}>
                    <h6 className="pres">{w?.title}</h6>
                    <p>{w?.description}</p>
                  </div>
                })
              }

            </div>
          </div>
        </div> */}
        {parse(data?.content)}

        <Link to="/pricing" className="regLink mt-5">
          Subscribe
        </Link>
      </div>
      <Top />
    </div >

  );
}

export default About;
